import React from 'react'
import { buildStaticProps } from '../../ssg/posts'
import GuidesLanding from '@/components/organisms/Guides/GuidesLanding'

function GuidesPage({ posts, total }: any) {
  return <GuidesLanding posts={posts} total={total} />
}

export async function getStaticProps({ query }: any) {
  const page = parseInt(query?.page, 10) || 1

  const { props } = await buildStaticProps(page)

  return { props, revalidate: 3600 }
}

export default GuidesPage
